// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__28NTt","fileBtn":"File_fileBtn__3LUx1","closeBtn":"File_closeBtn__DVGb4","fileSelected":"File_fileSelected__3xN3X","disabled":"File_disabled__3EPQc"};